var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.errors.length
    ? _c(
        "div",
        { staticClass: "form-general-messages grid grid__base" },
        _vm._l(_vm.errors, function(error, errorIdx) {
          return _c(
            "div",
            { key: errorIdx, staticClass: "form-general-messages--item" },
            [
              _c("span", { staticClass: "form-general-messages--text" }, [
                _vm._v("\n            " + _vm._s(error) + "\n        ")
              ])
            ]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ea41124", { render: render, staticRenderFns: staticRenderFns })
  }
}